import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Card, Tooltip, Typography, Empty } from 'antd'
import { InfoCircleOutlined } from '@ant-design/icons'
import { ResponsiveContainer } from 'recharts'

const { Text, Title } = Typography

class AnalyticsChart extends Component {
  render() {
    const {
      title,
      subtitle,
      info,
      height = 480,
      children,
      isEmpty = false,
      emptyText = 'No data available for this chart',
      className = '',
      style = {},
      extra,
    } = this.props

    const chartHeight = typeof height === 'number' ? height : parseInt(height, 10) || 480

    return (
      <Card
        className={`analytics-chart-card ${className}`}
        style={{
          borderRadius: 8,
          border: '1px solid #e8e8e8',
          boxShadow: '0 1px 4px rgba(0,0,0,0.04)',
          background: '#ffffff',
          ...style,
        }}
        bodyStyle={{ padding: '16px 20px 20px 20px', }}
      >
        <div
          className='analytics-chart-header'
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'flex-start',
            marginBottom: 16,
          }}
        >
          <div>
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                gap: 6,
              }}
            >
              <Title
                level={5}
                style={{
                  margin: 0,
                  fontSize: 15,
                  fontWeight: 600,
                  color: '#0a1227',
                }}
              >
                {title}
              </Title>
              {info && (
                <Tooltip title={info}>
                  <InfoCircleOutlined
                    style={{
                      color: '#8c8c8c',
                      fontSize: 13,
                      cursor: 'pointer',
                    }}
                  />
                </Tooltip>
              )}
            </div>
            {subtitle && (
              <Text
                type='secondary'
                style={{
                  fontSize: 12,
                  marginTop: 2,
                  display: 'block',
                }}
              >
                {subtitle}
              </Text>
            )}
          </div>
          {extra && <div>{extra}</div>}
        </div>

        <div
          className='analytics-chart-body'
          style={{
            width: '100%',
            height: chartHeight,
            minHeight: chartHeight,
            position: 'relative',
          }}
        >
          {isEmpty ? (
            <div
              style={{
                height: chartHeight,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
              }}
            >
              <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description={emptyText} />
            </div>
          ) : (
            <ResponsiveContainer width='100%' height={chartHeight}>
              {children}
            </ResponsiveContainer>
          )}
        </div>
      </Card>
    )
  }
}

AnalyticsChart.propTypes = {
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.string,
  info: PropTypes.string,
  height: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  children: PropTypes.node,
  isEmpty: PropTypes.bool,
  emptyText: PropTypes.string,
  className: PropTypes.string,
  style: PropTypes.object,
  extra: PropTypes.node,
}

export default AnalyticsChart

